export function TenoreT({ className = "" }: { className?: string }) {
  return (
    <svg
      className={`h-7 w-auto fill-current ${className}`}
      viewBox="0 0 100 181.1"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Tenore Logo"
    >
      <title>Tenore T</title>
      <g>
        <path d="M0,70.62v-18.76c0-1.1.9-2,2-2h96.88c1.1,0,2,.9,2,2v18.76c0,1.1-.9,2-2,2h-32.9c-1.1,0-2,.9-2,2v100.36c0,1.1-.9,2-2,2h-23.07c-1.1,0-2-.9-2-2v-100.36c0-1.1-.9-2-2-2H2c-1.1,0-2-.9-2-2Z" />
      </g>
    </svg>
  );
}
